<script setup lang="ts">
import {PropType, ref, watch} from "vue";
import {Spacing,Justify,FlexDirection,Align} from "../../tokens";

const emit = defineEmits(['select'])

const props = defineProps({
  options: {
    type: Array as PropType<any[]>,
    required: true,
  },
  defaultValue: {
    type: Object as PropType<any | undefined>,
    default: undefined
  },
  placeholder: {
    type: String,
    default: ''
  },
  listMaxHeight: {
    type: String,
    default: '30rem'
  }
});

const open = ref(false)
const selected = ref()

function select(option){
  open.value = false
  selected.value = option
  emit('select', option)
}

if(props.defaultValue){
  selected.value = props.defaultValue
}

watch(() => props.defaultValue, (newVal, oldVal) => {
  if(newVal != oldVal){
    selected.value = newVal
  }
})

</script>

<template>
    <div class="ods-dropdown" :class="{open}">
        <odsBox 
            :justify="Justify.SpaceBetween"
            :padding="Spacing.Small"
            :width="'auto'"
            class="ods-dropdown-display" 
            @click="open = true"
        >
            <div v-if="selected">
              <slot name="selected-item" :value="selected">
                {{ selected }}
              </slot>
            </div>
            <div v-else v-html="placeholder"></div>
            <odsIcon :name="'keyboard_arrow_down'"></odsIcon>
        </odsBox>
        <div class="ods-dropdown-backdrop" @click="open = false"></div>
        <odsBox 
            :direction="FlexDirection.Column"
            :justify="Justify.Start"
            :align="Align.Start"
            :padding="Spacing.None"
            :height="'auto'"
            class="ods-dropdown-list" 
            :style="{
              maxHeight: listMaxHeight
            }"
        >
            <odsBox 
                :direction="FlexDirection.Column"
                :justify="Justify.Start"
                :align="Align.Start"
                :padding="Spacing.None"
                :height="'auto'"
            >
                <odsBox
                    v-for="(option, index) in options"
                    :key="index"
                    :direction="FlexDirection.Column"
                    :align="Align.Start"
                    :padding="Spacing.None"
                    :gap="Spacing.Small"
                    class="ods-dropdown-item"
                    @click="select(option)"
                >
                    <slot name="list-item" :value="option" :index="index"></slot>
                </odsBox>
            </odsBox>
        </odsBox>
    </div>
</template>

<style lang="scss" src="./odsDropdown.scss"/>